import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-loading-info',
    templateUrl: './loading-info.component.html',
    styleUrls: ['./loading-info.component.less']
})
export class LoadingInfoComponent {
    @Input() title: string;
    @Input() text: string;
}
